import { render, staticRenderFns } from "./FraudManagement.vue?vue&type=template&id=d0df02d2&"
import script from "./FraudManagement.vue?vue&type=script&lang=js&"
export * from "./FraudManagement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports